/**
 * Nenásilné upozornění na blížící se konec životnosti (obnovu) předaných věcí.
 * Počítá se čistě na klientu z `datum_obnovy` — stejný princip jako zvýraznění
 * termínů u Úkolů (žádný cron/e-mail na backendu).
 */
import { useZamestnanci, useSharedZamestnanci } from '../../api/hooks';

/** Práh „blíží se obnova" ve dnech. */
export const OBNOVA_PRAH_DNI = 30;

export type ObnovaStav = 'po' | 'blizko' | 'ok';

/** Počet dní do data (záporné = už po termínu). null = neznámé/neplatné datum. */
export function daysUntil(iso?: string | null): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
  if (!m) return null;
  const target = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / 86_400_000);
}

export function obnovaStav(iso?: string | null): ObnovaStav | null {
  const d = daysUntil(iso);
  if (d === null) return null;
  if (d < 0) return 'po';
  if (d <= OBNOVA_PRAH_DNI) return 'blizko';
  return 'ok';
}

/**
 * Globální počet položek, které jsou po obnově nebo se k ní blíží — napříč mými
 * kartami i kartami nasdílenými mně. Slouží jako odznak v navigaci.
 */
export function useObnovaCount(): number {
  const { data: moje = [] } = useZamestnanci();
  const { data: sdilene = [] } = useSharedZamestnanci();
  let n = 0;
  for (const karta of [...moje, ...sdilene]) {
    for (const p of karta.polozky ?? []) {
      const s = obnovaStav(p.datum_obnovy);
      if (s === 'po' || s === 'blizko') n += 1;
    }
  }
  return n;
}
